import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    templateUrl: './app.layout.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppLayout {
}
